export default {
  Any: {
    legCode: 'Any',
    legName: 'Any Leg',
    nodes: [
      {
        label: 'Rail',
        value: 'Rail',
      },
      {
        label: 'Sea',
        value: 'Sea',
      },
      {
        label: 'Road',
        value: 'Road',
      },
      {
        label: 'Air',
        value: 'Air',
      },
    ],
  },
  First: {
    legCode: 'First',
    legName: 'First Leg',
    nodes: [
      {
        label: 'Rail',
        value: 'Rail',
      },
      {
        label: 'Sea',
        value: 'Sea',
      },
      {
        label: 'Road',
        value: 'Road',
      },
      {
        label: 'Air',
        value: 'Air',
      },
    ],
  },
  Last: {
    legCode: 'Last',
    legName: 'Last Leg',
    nodes: [
      {
        label: 'Rail',
        value: 'Rail',
      },
      {
        label: 'Sea',
        value: 'Sea',
      },
      {
        label: 'Road',
        value: 'Road',
      },
      {
        label: 'Air',
        value: 'Air',
      },
    ],
  },
  Each: {
    legCode: 'Each',
    legName: 'Each Leg',
    nodes: [
      {
        label: 'Rail',
        value: 'Rail',
      },
      {
        label: 'Sea',
        value: 'Sea',
      },
      {
        label: 'Road',
        value: 'Road',
      },
      {
        label: 'Air',
        value: 'Air',
      },
    ],
  },
};
